/** @format */

import {CampaignOptionsInterface} from '../../types';

export interface FilteredCampaigns {
  selected: CampaignOptionsInterface[];
  rejected: CampaignOptionsInterface[];
}

export const filterCampaignsByMask = (
  campaigns: CampaignOptionsInterface[],
  mask: string,
): FilteredCampaigns => {
  if (!mask.trim()) {
    return {selected: [], rejected: campaigns};
  }

  const lowerMask = mask.trim().toLowerCase();

  const selected: CampaignOptionsInterface[] = [];
  const rejected: CampaignOptionsInterface[] = [];

  for (const campaign of campaigns) {
    if (campaign.campaignName.toLowerCase().includes(lowerMask)) {
      selected.push(campaign);
    } else {
      rejected.push(campaign);
    }
  }

  return {selected, rejected};
};
